import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute  from '@/components/ProtectedRoute';
import Layout          from '@/components/Layout';
import LoginPage       from '@/pages/LoginPage';
import DashboardPage   from '@/pages/DashboardPage';

// Lazy-loaded pages (added as epics are built)
import AnbiyamPage      from '@/pages/AnbiyamPage';
import FamilyPage       from '@/pages/FamilyPage';
import FamilyDetailPage from '@/pages/FamilyDetailPage';
import FamilyFormPage   from '@/pages/FamilyFormPage';
import FamilyMemberFormPage from '@/pages/FamilyMemberFormPage';

// Epic 5/6/7 — Subscriptions, Cemetery, Non-Parish Cemetery
import SubscriptionsPage     from '@/pages/SubscriptionsPage';
import CemeteryPage          from '@/pages/CemeteryPage';
import NonParishCemeteryPage from '@/pages/NonParishCemeteryPage';
import BulkExportPage        from '@/pages/BulkExportPage';
import CollectionReviewPage  from '@/pages/CollectionReviewPage';

// User Management
import UserManagementPage from '@/pages/UserManagementPage';
import ActivityLogPage from '@/pages/ActivityLogPage';

// Anbiyam Map
import AnbiyamMapPage from '@/pages/AnbiyamMapPage';

// Analytics / Charts
import ChartsPage from '@/pages/ChartsPage';

// KAN-54 — Certificates
import CertificatesPage     from '@/pages/CertificatesPage';
import CertificateFormPage  from '@/pages/CertificateFormPage';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected — all routes inside Layout */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />

          {/* Epic 2 — Anbiyam */}
          <Route path="anbiyam"     element={<AnbiyamPage />} />
          <Route path="anbiyam-map" element={<AnbiyamMapPage />} />

          {/* Epic 3/4 — Families & Family Members */}
          <Route path="families"          element={<FamilyPage />} />
          <Route path="families/new"      element={<FamilyFormPage />} />
          <Route path="families/:id"      element={<FamilyDetailPage />} />
          <Route path="families/:id/edit" element={<FamilyFormPage />} />
          <Route path="families/:id/members/new"             element={<FamilyMemberFormPage />} />
          <Route path="families/:id/members/:memberId/edit"  element={<FamilyMemberFormPage />} />

          {/* Epic 5 — Family Subscriptions */}
          <Route path="subscriptions" element={<SubscriptionsPage />} />

          {/* Bulk Statement Export (Admin only) */}
          <Route path="subscriptions/bulk-export" element={<BulkExportPage />} />

          {/* Collection Sheet scan-back (Admin only) */}
          <Route path="subscriptions/collection-review" element={<CollectionReviewPage />} />

          {/* Epic 6 — Cemetery (parish) */}
          <Route path="cemetery" element={<CemeteryPage />} />

          {/* Epic 7 — Non-Parish Cemetery */}
          <Route path="non-parish-cemetery" element={<NonParishCemeteryPage />} />

          {/* KAN-54 — Certificates */}
          <Route path="certificates"            element={<CertificatesPage />} />
          <Route path="certificates/new"        element={<CertificateFormPage />} />
          <Route path="certificates/:id/edit"   element={<CertificateFormPage />} />
          <Route path="certificates/:id/print"  element={<CertificateFormPage mode="print" />} />

          {/* Analytics */}
          <Route path="charts" element={<ChartsPage />} />

          {/* User Management (Admin only) */}
          <Route path="users"        element={<UserManagementPage />} />
          <Route path="activity-log" element={<ActivityLogPage />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
